import { defineMessages } from 'react-intl';

import { TTaxProfile } from '../model/taxProfile';

export const taxProfileMessages = defineMessages<TTaxProfile>({
  general_vat: {
    defaultMessage: 'Standard VAT',
    id: 'tax_type_general_vat_regime',
    description: 'Tax profile option - Standard VAT',
  },
  flat_rate: {
    defaultMessage: 'Flat Rate Scheme',
    id: 'tax_type_flat_rate_scheme',
    description: 'Tax profile option - Flat Rate Scheme',
  },
  below_vat: {
    defaultMessage: 'Not VAT Registered',
    id: 'tax_type_below_vat_registration_threshold',
    description: 'Tax profile option - Not VAT Registered',
  },
});

export const vatFieldMessages = defineMessages({
  requiredError: {
    defaultMessage: 'VAT Reg No is required for selected tax profile.',
    id: 'field_error_vat_reg_no_required',
    description: 'VAT REG NO required error message',
  },
  patternError: {
    defaultMessage: "This is 9-12 digits, sometimes with 'GB' at the start.",
    id: 'field_error_vat_reg_no',
    description: 'Vat Reg No error message',
  },
  descriptionRequired: {
    defaultMessage: "This is 9–12 digits, sometimes with 'GB' at the start.",
    id: 'field_hint_vat_reg_no',
    description: 'Vat Reg No field description when required',
  },
  descriptionOptional: {
    defaultMessage: "Optional. This is 9–12 digits, sometimes with 'GB' at the start.",
    id: 'field_hint_vat_reg_no_optional',
    description: 'Vat Reg No field description',
  },
});
